import script from "./FieldDiffModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FieldDiffModal.vue?vue&type=script&setup=true&lang=ts"

import "./FieldDiffModal.vue?vue&type=style&index=0&id=6c9a5410&lang=postcss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9a5410"]])

export default __exports__